(() => {
  const initialized = new WeakSet();
  const desktop = window.matchMedia('(min-width: 990px)');
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function initialize(scope = document) {
    scope.querySelectorAll('[data-artzula-tisort-drawer]').forEach(drawer => {
      if (initialized.has(drawer)) return;
      initialized.add(drawer);
      [drawer, ...drawer.querySelectorAll('details')].forEach(details => {
        details.addEventListener('toggle', () => {
          details.querySelector(':scope > summary').setAttribute('aria-expanded', String(details.open));
          if (details.open) {
            requestAnimationFrame(() => {
              const panel = details.querySelector(':scope > .menu-drawer__submenu');
              const back = panel?.querySelector('.menu-drawer__close-button');
              if (details.open && panel && back && typeof trapFocus === 'function') trapFocus(panel, back);
            });
          }
        });
      });
    });

    scope.querySelectorAll('[data-artzula-tisort-menu]').forEach(menu => {
      if (initialized.has(menu)) return;
      initialized.add(menu);
      const root = menu.querySelector('.artzula-tisort-menu__root');
      const toggle = root.querySelector(':scope > summary');
      const mainLink = menu.querySelector(':scope > a');
      const groups = [...menu.querySelectorAll('[data-artzula-tisort-group]')];
      let closeTimer;
      let groupTimer;

      function close() {
        clearTimeout(closeTimer);
        clearTimeout(groupTimer);
        groups.forEach(group => { group.open = false; });
        root.open = false;
      }

      function openGroup(group) {
        clearTimeout(groupTimer);
        const focused = groups.find(item => item.contains(document.activeElement));
        if (focused && focused !== group && document.activeElement !== focused.querySelector(':scope > summary')) {
          focused.querySelector(':scope > summary').focus();
        }
        groups.forEach(item => { item.open = item === group; });
      }

      [root, ...groups].forEach(details => {
        details.addEventListener('toggle', () => {
          details.querySelector(':scope > summary').setAttribute('aria-expanded', String(details.open));
          if (details === root && !root.open) {
            groups.forEach(group => { group.open = false; });
          } else if (details !== root && details.open) {
            groups.forEach(group => { if (group !== details) group.open = false; });
          }
        });
      });

      menu.addEventListener('pointerenter', () => {
        clearTimeout(closeTimer);
        if (desktop.matches && hover.matches) root.open = true;
      });
      menu.addEventListener('pointerleave', () => {
        if (!hover.matches) return;
        clearTimeout(groupTimer);
        closeTimer = setTimeout(() => {
          if (!menu.contains(document.activeElement)) close();
        }, 220);
      });
      groups.forEach(group => {
        group.parentElement.addEventListener('pointerenter', () => {
          if (!desktop.matches || !hover.matches) return;
          clearTimeout(closeTimer);
          clearTimeout(groupTimer);
          groupTimer = setTimeout(() => {
            openGroup(group);
          }, 90);
        });
      });
      menu.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!menu.contains(document.activeElement) && !menu.matches(':hover')) close();
        });
      });
      menu.addEventListener('keyup', event => {
        if (desktop.matches && event.key === 'Escape') event.stopPropagation();
      }, true);
      menu.addEventListener('keydown', event => {
        if (!desktop.matches) return;
        const summary = event.target.closest('summary');
        const group = event.target.closest('[data-artzula-tisort-group]');
        const label = event.target.closest('.artzula-tisort-menu__label');
        const summaries = groups.map(item => item.querySelector(':scope > summary'));
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          if (group && group.open) {
            group.open = false;
            group.querySelector(':scope > summary').focus();
          } else {
            close();
            mainLink.focus();
          }
        } else if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && (event.target === mainLink || summary === toggle)) {
          event.preventDefault();
          root.open = true;
          summaries[event.key === 'ArrowDown' ? 0 : summaries.length - 1].focus();
        } else if (group && summary && (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Home' || event.key === 'End')) {
          event.preventDefault();
          let index = summaries.indexOf(summary);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = summaries.length - 1;
          else index = (index + (event.key === 'ArrowDown' ? 1 : -1) + summaries.length) % summaries.length;
          openGroup(null);
          summaries[index].focus();
        } else if (group && summary && event.key === 'ArrowRight') {
          event.preventDefault();
          openGroup(group);
          group.querySelector('.artzula-tisort-menu__label').focus();
        } else if (group && label && event.key === 'ArrowLeft') {
          event.preventDefault();
          group.open = false;
          group.querySelector(':scope > summary').focus();
        } else if (group && label && ['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          const labels = [...group.querySelectorAll('.artzula-tisort-menu__label')];
          let index = labels.indexOf(label);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = labels.length - 1;
          else index = (index + (event.key === 'ArrowDown' ? 1 : -1) + labels.length) % labels.length;
          labels[index].focus();
        }
      });
      menu.artzulaClose = close;
    });
  }

  document.addEventListener('pointerdown', event => {
    document.querySelectorAll('[data-artzula-tisort-menu]').forEach(menu => {
      if (!menu.contains(event.target)) menu.artzulaClose?.();
    });
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-artzula-tisort-menu]').forEach(menu => menu.artzulaClose?.());
  });
  desktop.addEventListener('change', () => {
    document.querySelectorAll('[data-artzula-tisort-menu]').forEach(menu => menu.artzulaClose?.());
  });
  initialize();
})();
